var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "my-loading",
          rawName: "v-my-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "contract"
    },
    [
      this.$route.query.isApp == 1
        ? _c("div", [
            !_vm.isLoading && _vm.linkType != 3
              ? _c("div", { staticClass: "contract-header" }, [
                  _c("div", [
                    _c("i", {
                      staticClass: "iconfont icon-xiangyou",
                      class: [_vm.isDirection ? "" : "mirrorRotateLevel"],
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.goBack.apply(null, arguments)
                        }
                      }
                    })
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            this.$route.query.isBanner == 0 && !_vm.isLoading
              ? _c("div", { staticClass: "contract-header" }, [
                  _c("div", [
                    _c("i", {
                      staticClass: "iconfont icon-xiangyou",
                      class: [_vm.isDirection ? "" : "mirrorRotateLevel"],
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.goBack.apply(null, arguments)
                        }
                      }
                    })
                  ])
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "scroll-box", class: { isiOS: _vm.isiOS } },
        [
          this.$route.query.isApp != 1
            ? _c("InCompleteSiteHead", { staticClass: "InCompleteSiteHead" })
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            staticClass: "contract-main",
            style: { "background-image": "url(" + _vm.config.h5Img + ")" }
          }),
          _vm._v(" "),
          _c(
            "div",
            { class: [_vm.config.content ? "ruleBtn" : "noRules"] },
            [
              _vm.istrue === 1 &&
              _vm.config.state === 1 &&
              _vm.config.endTime > new Date() * 1
                ? _c(
                    "van-button",
                    {
                      staticClass: "RegisterNow bold",
                      on: { click: _vm.application }
                    },
                    [_vm._v(_vm._s(_vm.$t("300352")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.istrue === 2 &&
              _vm.config.state === 1 &&
              _vm.config.endTime > new Date() * 1
                ? _c(
                    "van-button",
                    {
                      staticClass: "registered bold",
                      on: {
                        click: function($event) {
                          return _vm.activity_registration_click(2)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("300353")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.config.state === 1 && _vm.config.endTime < new Date() * 1
                ? _c(
                    "van-button",
                    {
                      staticClass: "registered bold",
                      on: {
                        click: function($event) {
                          return _vm.activity_registration_click(4)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("300354")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.config.content
                ? _c("div", { staticClass: "contractCompetition" }, [
                    _c("div", {
                      domProps: { innerHTML: _vm._s(_vm.config.content) }
                    })
                  ])
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.buySuccess
        ? _c(
            "div",
            { staticClass: "purchase-toast" },
            [
              _c("lottie", {
                staticClass: "lottie",
                attrs: { options: _vm.defaultOptions }
              }),
              _vm._v(" "),
              _c("p", { staticClass: "bold" }, [
                _vm._v(_vm._s(_vm.$t("300355")))
              ])
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ab351bf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ab351bf","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/contractCompetition/index.vue
// module id = 74Ct
// module chunks = 0